import type { SignatureRequestsBulkResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils/logging';

import { zodSignatureRequestsBulkResponseSchema } from './validations';

/**
 * Fetches signature requests for multiple delivery notes from the API.
 *
 * @param deliveryNoteIds - The IDs of the delivery notes. If null/empty, returns all signature requests.
 * @returns A promise that resolves with a map of delivery note IDs to signature requests.
 * @throws Error if the API request fails.
 */
export const fetchSignatureRequestsBulk = async (
  deliveryNoteIds?: UUID[] | null,
): Promise<SignatureRequestsBulkResponse> => {
  const response = await vestigasApi
    .post(ENDPOINT.DELIVERY_NOTE.QUERY_SIGNATURE_REQUESTS(), {
      json: {
        deliveryNoteIds,
      },
    })
    .json<SignatureRequestsBulkResponse>();

  const validatedResponse =
    zodSignatureRequestsBulkResponseSchema.safeParse(response);

  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Signature requests bulk API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
